// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import createDebugger from 'debug';
const debug = createDebugger('app:components:Paginator'); // eslint-disable-line no-unused-vars
import { Icon, IconLookup } from 'trustar-2.0/components';
import { DefaultTheme } from 'trustar-2.0/themes';
import type { ThemeType } from 'trustar-2.0/types';
import { inDarkMode } from 'trustar-2.0/themes/common';

// Style
const StyledPaginator = styled.div`
  display: inline-flex;
  height: ${props => (props.small ? '2rem' : '3.5rem')};
  flex-direction: row;

  > div {
    &:last-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &:first-child {
      margin-right: 1px;
      border-bottom-right-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
`;

const StyledPageButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3.5rem;
    width: 3.65rem;
    border: 1px solid ${({ theme }) => theme.ThemeColors.BLACK.X100};
    transform: rotate(180deg);
    background-color: ${({ theme }) => theme.ThemeColors.SURFACE.hex};
    cursor: pointer;
    
    &:hover {
        background-color: ${({ theme }) => theme.ThemeColors.BLACK.X50};
        i {
          color: ${({ theme }) => theme.ThemeColors.TEXT.hex} !important; 
        }
    }
    
    ${({ theme, disabledButton }) =>
      disabledButton &&
      css`
        opacity: 0.5;
        background-color: ${theme.ThemeColors.BLACK.X50};
        pointer-events: none;
        && > i {
          color: ${theme.ThemeColors.TEXT.hex};
        }
      `}    
    
    ${({ theme }) =>
      inDarkMode(theme) &&
      css`
        && {
          background-color: ${theme.ThemeColors.SEARCH_BAR.hex};
          color: ${theme.ThemeColors.BLACK.hex};
          border: 1px solid ${theme.ThemeColors.BORDER.hex};

          &:hover {
            background-color: ${theme.ThemeColors.SEARCH_BAR.X500};
            i {
              color: ${theme.ThemeColors.TEXT.hex} !important;
            }
          }

    
        }
      `}
    
    ${props =>
      props.small &&
      css`
        height: 2rem;
        width: 2.15rem;
      `}

    i {
      font-weight: 700;
      color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
      font-size: 0.7rem;
      
      
    }
`;

const initialValues = {
  disabled: false,
  theme: DefaultTheme
};

// Bindings
type PaginatorProps = {
  disabled: boolean,
  pageRight?: Function,
  pageLeft?: Function,
  disableLeft?: boolean,
  disableRight?: boolean,
  small?: any,
  theme: ThemeType
};

class Paginator extends Component {
  props: PaginatorProps;
  static defaultProps = initialValues;

  //  ----Template----

  render() {
    const {
      disableLeft,
      disableRight,
      pageRight,
      pageLeft,
      small,
      disabled,
      theme
    } = this.props;

    const canPageLeft = () => !(disabled || disableLeft);
    const canPageRight = () => !(disabled || disableRight);

    const safePageLeft = () => (canPageLeft() ? pageLeft : () => {});
    const safePageRight = () => (canPageRight() ? pageRight : () => {});
    return (
      <StyledPaginator {...this.props}>
        <StyledPageButton
          small={small}
          onClick={safePageLeft()}
          aria-label='backward'
          disabledButton={!canPageLeft()}>
          <Icon icon={IconLookup.CHEVRON_RIGHT} />
        </StyledPageButton>
        <StyledPageButton
          small={small}
          onClick={safePageRight()}
          aria-label='forward'
          disabledButton={!canPageRight()}>
          <Icon icon={IconLookup.CHEVRON_LEFT} />
        </StyledPageButton>
      </StyledPaginator>
    );
  }

  // ----Lifecycle Hooks----

  // ----Methods----

  methodOne = (option: Object) => {};
}

// Connect To State
const mapStateToProps = state => ({
  disabled: false // Some variable,
});

const dispatchProps = {
  methodOne: () => {} // Some action
};

// export

export { Paginator, Paginator as PureComponent, StyledPageButton, StyledPaginator };



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Paginator.js